import styled from 'styled-components';
import { Tab } from 'ui/tabs';
import { body1, colors, spacing } from 'ui/theme';

export const TabsContainer = styled.div`
  /** this is to offset the padding of the parent editor container. */
  margin-left: -${spacing.plusHalf};

  margin-top: ${spacing.threeQuarter};
`;

export const StyledTab = styled(Tab)<{ isSelected: boolean }>`
  ${body1}
  font-weight: normal;
  height: ${spacing.x4};
  margin-right: ${spacing.half};
  color: ${({ isSelected }) => (isSelected ? colors.purple100 : colors.textSecondary)};
  border-width: ${spacing.quarter};
  border-bottom-color: ${({ isSelected }) => (isSelected ? colors.purple100 : 'transparent')};
`;

export const Divider = styled.div`
  background-color: ${colors.grey15};
  height: ${spacing.eighth};

  /** this is to offset the padding of the parent editor container. */
  width: calc(100% + ${spacing.plusHalf});
`;

export const StyledSVGContainer = styled.div`
  display: flex;
  gap: ${spacing.quarter};
`;
